import React from 'react';
import Icon from '../../../components/AppIcon';


const QuickActions = ({ loading = false }) => {
  const actions = [
    {
      id: 1,
      title: 'Add Transaction',
      description: 'Log a new expense or income',
      icon: 'Plus',
      color: 'var(--color-primary)',
      bgColor: 'bg-fintech-blue-100',
      hoverColor: 'hover:bg-fintech-blue-200'
    },
    {
      id: 2,
      title: 'Create Budget',
      description: 'Set spending limits for categories',
      icon: 'Target',
      color: 'var(--color-success)',
      bgColor: 'bg-fintech-green-100',
      hoverColor: 'hover:bg-fintech-green-200'
    },
    {
      id: 3,
      title: 'Set Goal',
      description: 'Define a new savings target',
      icon: 'TrendingUp',
      color: 'var(--color-warning)',
      bgColor: 'bg-yellow-100',
      hoverColor: 'hover:bg-yellow-200'
    },
    {
      id: 4,
      title: 'View Reports',
      description: 'Analyze your financial trends',
      icon: 'BarChart',
      color: 'var(--color-secondary)',
      bgColor: 'bg-fintech-purple-100',
      hoverColor: 'hover:bg-fintech-purple-200'
    }
  ];

  if (loading) {
    return (
      <div className="bg-card rounded-2xl p-4 md:p-6 shadow-elevation-2">
        <div className="mb-6">
          <div className="h-6 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded w-32 mb-2 animate-shimmer" style={{ backgroundSize: '200% 100%' }} />
          <div className="h-4 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded w-48 animate-shimmer" style={{ backgroundSize: '200% 100%' }} />
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {[...Array(4)]?.map((_, i) => (
            <div key={i} className="p-4 rounded-xl bg-muted animate-pulse">
              <div className="flex items-center gap-3 mb-2">
                <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-gray-200 to-gray-300" />
                <div className="flex-1 space-y-2">
                  <div className="h-4 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded w-3/4 animate-shimmer" style={{ backgroundSize: '200% 100%' }} />
                  <div className="h-3 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded w-full animate-shimmer" style={{ backgroundSize: '200% 100%' }} />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="bg-card rounded-2xl p-4 md:p-6 shadow-elevation-2 hover:shadow-elevation-3 transition-all duration-300">
      <div className="mb-6">
        <h2 className="text-lg md:text-xl font-semibold text-foreground mb-1">Quick Actions</h2>
        <p className="text-sm text-muted-foreground">Common tasks and shortcuts</p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {actions?.map((action, index) => (
          <button
            key={action?.id}
            className={`p-4 rounded-xl ${action?.bgColor} ${action?.hoverColor} transition-all duration-300 hover:shadow-elevation-2 hover:scale-[1.03] hover:-translate-y-0.5 text-left group animate-fade-in`}
            style={{ animationDelay: `${index * 0.1}s` }}
          >
            <div className="flex items-center gap-3 mb-2">
              <div className="w-10 h-10 rounded-lg flex items-center justify-center transition-all duration-300 group-hover:scale-110 group-hover:rotate-3" style={{ backgroundColor: `${action?.color}20` }}>
                <Icon name={action?.icon} size={20} color={action?.color} />
              </div>
              <div className="flex-1">
                <h3 className="text-sm font-semibold text-foreground transition-colors duration-200 group-hover:text-primary">{action?.title}</h3>
                <p className="text-xs text-muted-foreground">{action?.description}</p>
              </div>
              <Icon name="ChevronRight" size={16} className="text-muted-foreground transition-transform duration-200 group-hover:translate-x-1" />
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default QuickActions;